import React, { useState } from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Tooltip from '@mui/material/Tooltip';
import Menu from '@mui/material/Menu';
import { useParams, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { deleteProject } from '#action/project/dashboard';
import DeleteDialog from '#component/project/delete-dialog';
import UserLocalStorage from '#utils/user-local-storage';
import { isUser, isDevice, getUserDeviceID } from '#component/project/dashboard/helper';
import { StyledButton, StyledIcon, StyledMenuItem } from './styles';

/**
 * Renders MUI Button with with menu action
 * to delete project.
 * @returns {React.ReactFragment}
 */

const FormActions = props => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const { children, projectTitle } = props;
  const projectsFilter = UserLocalStorage.getData('projectsFilter') ?? [];

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    handleClose();
  };

  const handleDelete = async () => {
    handleClose();

    const { success } = await dispatch(deleteProject(id));
    if (success) {
      if (projectsFilter.length) {
        const newFilter = projectsFilter.filter(pf => {
          const filterItemId = (isUser(pf) || isDevice(pf)) ? +getUserDeviceID(pf) : pf;
          return !(filterItemId === +id);
        });
        UserLocalStorage.setData('projectsFilter', newFilter);
      }
      history.push('/project');
    }
  };

  return (
    <>
      <Tooltip title="Project actions">
        <StyledButton onClick={handleClick}>
          <ArrowDropDownIcon />
          {children}
        </StyledButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <StyledMenuItem onClick={handleOpenDialog}>
          <StyledIcon />
          Delete project
        </StyledMenuItem>
      </Menu>
      <DeleteDialog
        title={projectTitle}
        open={openDialog}
        onClose={handleCloseDialog}
        onDelete={handleDelete}
      />
    </>
  );
};

export default FormActions;
